<script lang="ts">
import { computed } from 'vue';

export type PhxsgLoaderTheme = 'light' | 'dark';

export interface PhxsgLoaderProps {
  light?: boolean;
  size?: string;
  type?: 'circle' | 'line';
  showOverlay?: boolean;
  overlayTheme?: PhxsgLoaderTheme;
  softEdges?: boolean;
}
</script>

<script setup lang="ts">
const {
  type = 'circle',
  light,
  size,
  showOverlay,
  overlayTheme = 'light',
  softEdges,
} = defineProps<PhxsgLoaderProps>();

const loaderClasses = computed(() => [
  'phxsg-loader',
  `phxsg-loader--${type}`,
  {
    'phxsg-loader--light': light,
    'phxsg-loader--dark': !light,
    [`phxsg-loader--${size}`]: size,
  },
]);

const overlayClasses = computed(() => [
  'phxsg-loader-overlay',
  `phxsg-loader-overlay--${overlayTheme}`,
  { 'phxsg-loader-overlay--soft-edge': softEdges },
]);
</script>

<template>
  <div v-if="showOverlay" :class="overlayClasses">
    <div :class="loaderClasses" role="presentation">
      <div class="phxsg-loader__inner" />
    </div>
  </div>

  <div v-else :class="loaderClasses" role="presentation">
    <div class="phxsg-loader__inner" />
  </div>
</template>

<style src="./loader.css" />
<style src="./loader-overlay.css" />
